import { apiClient } from './api';
import type {
  TenantBootstrapResponse,
  TenantInvitationAcceptPayload,
  TenantInvitationCreatePayload,
  TenantInvitationRefreshPayload,
  TenantInvitationSummary,
  TenantMemberSummary,
  TenantJoinCodeCreatePayload,
  TenantJoinCodeRedeemPayload,
  TenantJoinCodeSummary,
  TenantOnboardingAccessResponse,
} from '../types';

export async function getTenantOnboardingAccess(): Promise<TenantOnboardingAccessResponse> {
  const response = await apiClient.get<TenantOnboardingAccessResponse>('/api/v1/web/tenant-onboarding/access');
  return response.data;
}

export async function createTenantJoinCode(payload: TenantJoinCodeCreatePayload): Promise<TenantJoinCodeSummary> {
  const response = await apiClient.post<TenantJoinCodeSummary>('/api/v1/web/tenant-onboarding/join-codes', payload);
  return response.data;
}

export async function revokeTenantJoinCode(joinCodeId: number): Promise<TenantJoinCodeSummary> {
  const response = await apiClient.post<TenantJoinCodeSummary>(`/api/v1/web/tenant-onboarding/join-codes/${joinCodeId}/revoke`);
  return response.data;
}

export async function createTenantInvitation(payload: TenantInvitationCreatePayload): Promise<TenantInvitationSummary> {
  const response = await apiClient.post<TenantInvitationSummary>('/api/v1/web/tenant-onboarding/invitations', payload);
  return response.data;
}

export async function revokeTenantInvitation(invitationId: number): Promise<TenantInvitationSummary> {
  const response = await apiClient.post<TenantInvitationSummary>(`/api/v1/web/tenant-onboarding/invitations/${invitationId}/revoke`);
  return response.data;
}

export async function refreshTenantInvitation(
  invitationId: number,
  payload: TenantInvitationRefreshPayload = {}
): Promise<TenantInvitationSummary> {
  const response = await apiClient.post<TenantInvitationSummary>(`/api/v1/web/tenant-onboarding/invitations/${invitationId}/refresh`, payload);
  return response.data;
}

export async function deactivateTenantMembership(membershipId: number): Promise<TenantMemberSummary> {
  const response = await apiClient.post<TenantMemberSummary>(`/api/v1/web/tenant-onboarding/memberships/${membershipId}/deactivate`);
  return response.data;
}

export async function reactivateTenantMembership(membershipId: number): Promise<TenantMemberSummary> {
  const response = await apiClient.post<TenantMemberSummary>(`/api/v1/web/tenant-onboarding/memberships/${membershipId}/reactivate`);
  return response.data;
}

export async function redeemTenantJoinCode(payload: TenantJoinCodeRedeemPayload): Promise<TenantBootstrapResponse> {
  const response = await apiClient.post<TenantBootstrapResponse>('/api/v1/web/tenant-onboarding/redeem-code', payload);
  return response.data;
}

export async function acceptTenantInvitation(payload: TenantInvitationAcceptPayload): Promise<TenantBootstrapResponse> {
  const response = await apiClient.post<TenantBootstrapResponse>('/api/v1/web/tenant-onboarding/accept-invitation', payload);
  return response.data;
}
